import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router';
import { isNil } from '@roc/feature-utils';
import { VerticalBarLoader } from '@roc/ui';
import { useStore } from '@roc/client-portal-shared/hooks';
import { MainScreen } from './mainScreen';
import { Box } from '@material-ui/core';


export const CollateralCompScreen = observer(
  () => {
    const { compToolStoreV2: compToolStore } = useStore();
    const { searchPropertyFormStore } = compToolStore;

    const { address } = useParams<{ address: string }>();
    const location = useLocation();

    const params = new URLSearchParams(location.search);
    const loanId = parseInt(params.get('loanId'));
    const propertyId = parseInt(params.get('propertyId'));

    const { loading } = compToolStore;

    useEffect(() => {
      const fetchLoanDetails = async () => {
        searchPropertyFormStore.saveAddressField(address);
        searchPropertyFormStore.onFieldChange('completeAddress', address);
        compToolStore.setShowWarningMessage(false);

        if (!isNil(address) && address !== "") {
          compToolStore.reset();

          if (loanId && propertyId) {
            compToolStore.setLoanInformation(loanId, propertyId);
          }

          await compToolStore.getPropertyById(propertyId);

          if (compToolStore.property) {
            searchPropertyFormStore.saveAddressField(address, null, null, compToolStore.property.latitude, compToolStore.property.longitude);
          }

          compToolStore.fetchCompToolProperties(1, true);

        } else {
          compToolStore.compResponse = null;
          compToolStore.setShowWarningMessage(true);
          compToolStore.setLoanInformation(null, null);
        }
      };

      fetchLoanDetails();
    }, [loanId, propertyId, address, searchPropertyFormStore, compToolStore]);

    return (
      <Box width="100%">
        {loading ? (
          <VerticalBarLoader />
        ) : (
          <MainScreen />
        )}
      </Box>

    );
  }
);
